// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_a5-0";
export var optionCard = "_a5-1";